<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.4em" v-if="step != 1">
            <v-btn icon @click="step = 1">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            {{titulo()}}
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <v-layout v-if="step === 1">
                <v-btn icon @click="$emit('fechar')"> <v-icon>close</v-icon> </v-btn>
            </v-layout>
            <v-stepper v-model="step" style="box-shadow: none" class="ma-0 pa-0">
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-layout wrap justify-space-around style="font-size: 1.2em">
                            <v-flex xs10 sm5 lg5 xl5 class="mb-2 mr-1 ml-1 mt-2" v-for="(item, index) in menu" :key="index">
                                <v-card elevation="5"
                                    min-height="10em"
                                    hover
                                    @click="passarTela(index + 2)"
                                    :color="item.color"
                                    dark
                                >
                                    <v-card-text>
                                        <v-layout justify-center column>
                                            <v-icon size="5em">{{item.icon}}</v-icon>
                                            <h4 style="font-size: 1em; text-align: center; font-weight: 900;">{{item.text}}</h4>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout justify-space-between wrap>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    label="Placa"
                                    v-model="veiculo_data.identificacao"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    class="ma-0 pa-0"
                                    hide-details
                                    hide-spin-buttons
                                >

                                </v-text-field>
                                <h5
                                    v-if="placa_existe"
                                    class="error--text text-xs-center"
                                    style="font-size: 1.0em"
                                >
                                    * Placa já foi registrada
                                </h5>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    label="Modelo e Marca"
                                    v-model="veiculo_data.modelo_marca"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                >

                                </v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    label="Modelo"
                                    v-model="veiculo_data.modelo"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                >

                                </v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    label="Marca"
                                    v-model="veiculo_data.marca"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                >

                                </v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-select
                                    label="Cor"
                                    v-model="veiculo_data.cor_texto"
                                    :items="[
                                        'Branca',
                                        'Preta',
                                        'Prata',
                                        'Cinza',
                                        'Vermelha',
                                        'Azul',
                                        'Rosa',
                                        'Amarelo'
                                    ]"
                                    outline
                                >
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <v-layout wrap justify-space-around class="mb-4">
                            <v-flex xs4 class="ml-1" v-if="veiculo_data.usuario">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="veiculo_data.usuario = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Atual Proprietário</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                veiculo_data.usuario &&
                                                veiculo_data.usuario.pessoa &&
                                                veiculo_data.usuario.pessoa.url_imagem_perfil"
                                                :src="veiculo_data.usuario.pessoa.url_imagem_perfil"
                                                alt="Imagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">account_circle</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                veiculo_data.usuario &&
                                                veiculo_data.usuario.pessoa &&
                                                veiculo_data.usuario.pessoa.nome_completo
                                            ">
                                            Nome: {{veiculo_data.usuario.pessoa.nome_completo}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.usuario &&
                                                veiculo_data.usuario.pessoa &&
                                                veiculo_data.usuario.pessoa.cpf
                                            ">
                                            CPF: {{veiculo_data.usuario.pessoa.cpf}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.usuario &&
                                                veiculo_data.usuario.pessoa &&
                                                veiculo_data.usuario.pessoa.email
                                            ">
                                            E-mail: {{veiculo_data.usuario.pessoa.email}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs5 class="ml-1" v-else-if="!usuario && !veiculo_data.usuario">
                                <h4 class="text-xs-center" v-if="!veiculo.usuario">Não há um Proprietário Responsável</h4>
                                <h4 class="text-xs-center" v-else>Você Removeu o Usuário Responsável</h4>
                            </v-flex>
                            <v-flex
                                v-if="usuario && veiculo_data.usuario && usuario!== veiculo_data.usuario"
                                xs1
                                style="
                                    justify-content: center;
                                    display: flex;
                                "
                                align-self-center
                            >
                                <v-icon size="4em">
                                    sync_alt
                                </v-icon>
                            </v-flex>
                            <v-flex xs4 v-if="usuario && usuario!== veiculo.usuario">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="usuario = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Novo Proprietário</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                    usuario &&
                                                    usuario.pessoa &&
                                                    usuario.pessoa.url_imagem_perfil
                                                "
                                                :src="usuario.pessoa.url_imagem_perfil"
                                                alt="Umagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">account_circle</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                usuario &&
                                                usuario.pessoa &&
                                                usuario.pessoa.nome_completo
                                            ">
                                            Nome: {{usuario.pessoa.nome_completo}}
                                        </h4>
                                        <h4 v-if="
                                                usuario &&
                                                usuario.pessoa &&
                                                usuario.pessoa.cpf
                                            ">
                                            CPF: {{usuario.pessoa.cpf}}
                                        </h4>
                                        <h4 v-if="
                                                usuario &&
                                                usuario.pessoa &&
                                                usuario.pessoa.email
                                            ">
                                            E-mail: {{usuario.pessoa.email}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap justify-space-between>
                            <v-flex xs5>
                                <v-select
                                    outline
                                    v-model="procurar"
                                    label="Procurar por"
                                    :items="[
                                        'CPF',
                                        'E-mail'
                                    ]"
                                />
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    :label="`Digite o ${procurar} do usuário`"
                                    v-model="pesquisa"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 align-self-center style="justify-content: center; display: flex;">
                                <v-list style="width: 70%;">
                                    <template v-for="(item, index) in usuarios">
                                        <v-divider
                                            v-if="index > 0"
                                            :key="`${index}d`"
                                            inset
                                        ></v-divider>
                                        <v-list-tile
                                            class="mb-1"
                                            :key="`${index}i`"
                                            ripple
                                            @click="
                                                usuario = item,
                                                usuarios = [usuario]"
                                        >
                                            <v-list-tile-avatar>
                                                <v-avatar
                                                color="grey"
                                                size="30">
                                                <img v-if="item.pessoa && item.pessoa.url_imagem_perfil" :src="item.pessoa.url_imagem_perfil">
                                                <v-icon dark v-else>face</v-icon>
                                            </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    {{item.pessoa.nome_completo}}
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    {{item.pessoa.cpf}}
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <v-layout wrap justify-space-around class="mb-4">
                            <v-flex xs4 class="ml-1" v-if="veiculo_data.empresa">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="veiculo_data.empresa = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Atual Empresa Proprietária</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                veiculo_data.empresa &&
                                                veiculo_data.empresa.url_logo"
                                                :src="veiculo_data.empresa.url_logo"
                                                alt="Imagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">domain</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                veiculo_data.empresa &&
                                                veiculo_data.empresa.nome_fantasia
                                            ">
                                            Nome Fantasia: {{veiculo_data.empresa.nome_fantasia}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.empresa &&
                                                veiculo_data.empresa.cnpj
                                            ">
                                            CNPJ: {{veiculo_data.empresa.cnpj}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.empresa &&
                                                veiculo_data.empresa.razao_social
                                            ">
                                            Razão social: {{veiculo_data.empresa.razao_social}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs5 class="ml-1" v-else-if="!empresa && !veiculo_data.empresa">
                                <h4 class="text-xs-center" v-if="!veiculo.empresa">Não há uma Empresa Responsável</h4>
                                <h4 class="text-xs-center" v-else>Você Removeu a Empresa Responsável</h4>
                            </v-flex>
                            <v-flex
                                v-if="empresa && veiculo_data.empresa && empresa !== veiculo_data.empresa"
                                xs1
                                style="
                                    justify-content: center;
                                    display: flex;
                                "
                                align-self-center
                            >
                                <v-icon size="4em">
                                    sync_alt
                                </v-icon>
                            </v-flex>
                            <v-flex xs4 class="ml-1" v-if="empresa && empresa !== veiculo_data.empresa">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="empresa = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Nova Empresa Proprietária</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                empresa &&
                                                empresa.url_logo"
                                                :src="empresa.url_logo"
                                                alt="Imagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">domain</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                empresa &&
                                                empresa.nome_fantasia
                                            ">
                                            Nome Fantasia: {{empresa.nome_fantasia}}
                                        </h4>
                                        <h4 v-if="
                                                empresa &&
                                                empresa.cnpj
                                            ">
                                            CNPJ: {{empresa.cnpj}}
                                        </h4>
                                        <h4 v-if="
                                                empresa &&
                                                empresa.razao_social
                                            ">
                                            Razão social: {{empresa.razao_social}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap justify-space-between>
                            <v-flex xs5>
                                <v-select
                                    outline
                                    v-model="procurar_empresa"
                                    label="Procurar por"
                                    :items="[
                                        'CNPJ',
                                        'Nome Fantasia'
                                    ]"
                                />
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    :label="`Digite o ${procurar_empresa} da empresa`"
                                    v-model="pesquisa_empresa"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 align-self-center style="justify-content: center; display: flex;">
                                <v-list style="width: 70%;">
                                    <template v-for="(item, index) in empresas">
                                        <v-divider
                                            v-if="index > 0"
                                            :key="`${index}d`"
                                            inset
                                        ></v-divider>
                                        <v-list-tile
                                            class="mb-1"
                                            :key="`${index}i`"
                                            ripple
                                            @click="
                                                empresa = item,
                                                empresas = [empresa]"
                                        >
                                            <v-list-tile-avatar>
                                                <v-avatar
                                                color="grey"
                                                size="30">
                                                <img v-if="item.url_logo" :src="item.url_logo">
                                                <v-icon dark v-else>face</v-icon>
                                            </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    {{item.nome_fantasia}}
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    {{item.cnpj}}
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                        <v-layout wrap justify-space-around class="mb-4">
                            <v-flex xs4 class="ml-1" v-if="veiculo_data.motorista">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="veiculo_data.motorista = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Atual Funcionário Responsável</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                veiculo_data.motorista &&
                                                veiculo_data.motorista.pessoa &&
                                                veiculo_data.motorista.pessoa.url_imagem_perfil"
                                                :src="veiculo_data.motorista.pessoa.url_imagem_perfil"
                                                alt="Imagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">account_circle</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                veiculo_data.motorista &&
                                                veiculo_data.motorista.pessoa &&
                                                veiculo_data.motorista.pessoa.nome_completo
                                            ">
                                            Nome: {{veiculo_data.motorista.pessoa.nome_completo}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.motorista &&
                                                veiculo_data.motorista.pessoa &&
                                                veiculo_data.motorista.pessoa.cpf
                                            ">
                                            CPF: {{veiculo_data.motorista.pessoa.cpf}}
                                        </h4>
                                        <h4 v-if="
                                                veiculo_data.motorista &&
                                                veiculo_data.motorista.pessoa &&
                                                veiculo_data.motorista.pessoa.email
                                            ">
                                            E-mail: {{veiculo_data.motorista.pessoa.email}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs5 class="ml-1" v-else-if="!motorista && !veiculo_data.motorista">
                                <h4 class="text-xs-center" v-if="!veiculo.motorista">Não há um Funcionário Responsável</h4>
                                <h4 class="text-xs-center" v-else>Você Removeu o Funcionário Responsável</h4>
                            </v-flex>
                            <v-flex
                                v-if="motorista && veiculo_data.motorista && motorista!== veiculo_data.motorista"
                                xs1
                                style="
                                    justify-content: center;
                                    display: flex;
                                "
                                align-self-center
                            >
                                <v-icon size="4em">
                                    sync_alt
                                </v-icon>
                            </v-flex>
                            <v-flex xs4 v-if="motorista && motorista!== veiculo_data.motorista">
                                <v-card min-height="23em">
                                    <v-card-text>
                                        <v-layout>
                                            <v-btn class="ma-0" icon @click="motorista = undefined">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                            <h3 class="text-xs-center mb-2 mt-1">Novo Funcionário Responsável</h3>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        <v-layout
                                            justify-center
                                            class="mb-4"
                                            full-weith
                                        >
                                            <img
                                                width="70%"
                                                v-if="
                                                    motorista &&
                                                    motorista.pessoa &&
                                                    motorista.pessoa.url_imagem_perfil
                                                "
                                                :src="motorista.pessoa.url_imagem_perfil"
                                                alt="Umagem do Usuário"
                                                style="border-radius: 15em"
                                            >
                                            <v-avatar
                                                v-else
                                                color="primary"
                                                size="140"
                                                dark
                                            >
                                                <v-icon size="100" color="white">account_circle</v-icon>
                                            </v-avatar>
                                        </v-layout>
                                        <h4 v-if="
                                                motorista &&
                                                motorista.pessoa &&
                                                motorista.pessoa.nome_completo
                                            ">
                                            Nome: {{motorista.pessoa.nome_completo}}
                                        </h4>
                                        <h4 v-if="
                                                motorista &&
                                                motorista.pessoa &&
                                                motorista.pessoa.cpf
                                            ">
                                            CPF: {{motorista.pessoa.cpf}}
                                        </h4>
                                        <h4 v-if="
                                                motorista &&
                                                motorista.pessoa &&
                                                motorista.pessoa.email
                                            ">
                                            E-mail: {{motorista.pessoa.email}}
                                        </h4>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap justify-space-between>
                            <v-flex xs5>
                                <v-select
                                    outline
                                    v-model="procurar_motorista"
                                    label="Procurar por"
                                    :items="[
                                        'CPF',
                                        'E-mail'
                                    ]"
                                />
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    outline
                                    :label="`Digite o ${procurar_motorista} do funcionário`"
                                    v-model="pesquisa_motorista"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 align-self-center style="justify-content: center; display: flex;">
                                <v-list style="width: 70%;">
                                    <template v-for="(item, index) in motoristas">
                                        <v-divider
                                            v-if="index > 0"
                                            :key="`${index}d`"
                                            inset
                                        ></v-divider>
                                        <v-list-tile
                                            class="mb-1"
                                            :key="`${index}i`"
                                            ripple
                                            @click="
                                                motorista = item,
                                                motoristas = [motorista]"
                                        >
                                            <v-list-tile-avatar>
                                                <v-avatar
                                                color="grey"
                                                size="30">
                                                <img v-if="item.pessoa && item.pessoa.url_imagem_perfil" :src="item.pessoa.url_imagem_perfil">
                                                <v-icon dark v-else>face</v-icon>
                                            </v-avatar>
                                            </v-list-tile-avatar>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    {{item.pessoa.nome_completo}}
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    {{item.pessoa.cpf}}
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
        <v-card-actions v-if="step != 1">
            <v-btn
                class="mb-2"
                block
                round
                @click="$emit('fechar')"
            >
                Fechar
            </v-btn>
            <v-btn
                class="mb-2"
                block
                round
                @click="salvarAlteracao"
                color="success"
                :disabled="disabled"
            >
                Confirmar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['veiculo'],
    data: () => ({
        step: 1,
        menu: [
            { text: 'Editar Dados Veículo', icon: 'airport_shuttle', color: 'error' },
            { text: 'Trocar Usuário Responsável', icon: 'account_circle', color: 'primary' },
            { text: 'Trocar Empresa Responsável', icon: 'business', color: 'success' },
            { text: 'Trocar Funcionário Responsável', icon: 'engineering', color: 'info' }
        ],
        veiculo_data: undefined,
        usuario: undefined,
        motorista: undefined,
        empresa: undefined,
        usuarios: [],
        motoristas: [],
        empresas: [],
        procurar: 'CPF',
        procurar_empresa: 'CNPJ',
        procurar_motorista: 'CPF',
        pesquisa: undefined,
        pesquisa_empresa: undefined,
        pesquisa_motorista: undefined,
        placa_existe: false
    }),
    computed: {
        disabled () {
            switch (this.step) {
                case 2:
                    if (
                        !this.veiculo_data.identificacao ||
                        !this.veiculo_data.modelo_marca ||
                        this.placa_existe
                    ) return true
                    return false
                case 3:
                    if (!this.usuario && !this.veiculo_data.usuario && !this.veiculo.usuario) return true
                    else if (this.veiculo_data.usuario && this.veiculo.usuario === this.veiculo_data.usuario && !this.usuario) return true
                    return false
                case 4:
                    if (!this.empresa && !this.veiculo_data.empresa && !this.veiculo.empresa) return true
                    else if (this.veiculo_data.empresa && this.veiculo.empresa === this.veiculo_data.empresa && !this.empresa) return true
                    return false
                case 5:
                    if (!this.motorista && !this.veiculo_data.motorista && !this.veiculo.motorista) return true
                    else if (this.veiculo_data.motorista && this.veiculo.motorista === this.veiculo_data.motorista && !this.motorista) return true
                    return false
                default:
                    return true
            }
        }
    },
    methods: {
        passarTela (numero) {
            this.step = numero
        },
        pegarClientes () {
            if (!this.pesquisa) {
                this.$emit('Você precisa preencher o campo.')
                return
            }

            const data = {}
            if (this.procurar === 'CPF') data.pessoa__cpf__icontains = this.pesquisa
            else data.pessoa__email__icontains = this.pesquisa

            this.$store.dispatch('pegarClientes', data).then(json => {
                this.usuarios = json.results
            })
        },
        pegarEmpresas () {
            if (!this.pesquisa_empresa) {
                this.$emit('Você precisa preencher o campo.')
                return
            }

            const data = {}
            if (this.procurar_empresa === 'CNPJ') data.cnpj__icontains = this.pesquisa_empresa
            else data.nome_fantasia__icontains = this.pesquisa_empresa

            this.$store.dispatch('procurarEmpresasPorAdm', { filtros: data }).then(json => {
                this.empresas = json
            })
        },
        pegarFuncionarios () {
            if (!this.pesquisa_motorista) {
                this.$emit('error', 'Você precisa preencher o campo.')
                return
            }

            const data = {}
            if (this.veiculo.empresa) data.empresa__cnpj = this.veiculo.empresa.cnpj
            if (this.procurar_motorista === 'CPF') data.pessoa__cpf__icontains = this.pesquisa_motorista
            else data.pessoa__email__icontains = this.pesquisa_motorista

            this.$store.dispatch('pegarFuncionarios', data).then(json => {
                this.motoristas = json
            })
        },
        salvarAlteracao () {
            const data = { id_veiculo: this.veiculo.id_veiculo }

            switch (this.step) {
                case 2:
                    data.identificacao = this.veiculo_data.identificacao
                    data.modelo_marca = this.veiculo_data.modelo_marca
                    data.modelo = this.veiculo_data.modelo
                    data.marca = this.veiculo_data.marca
                    data.cor = this.veiculo_data.cor
                    data.cor_texto = this.veiculo_data.cor_texto
                    break
                case 3:
                    data.id_usuario = this.usuario ? this.usuario.id_cliente : null
                    break
                case 4:
                    data.id_empresa = this.empresa ? this.empresa.cnpj : null
                    break
                case 5:
                    data.id_motorista = this.motorista ? this.motorista.id_funcionario : null
                    break
            }

            this.$store.dispatch('editarVeiculo', data).then(() => {
                this.$emit('success', 'Veículo alterado com sucesso.')
                this.$emit('carregar')
                this.$emit('fechar')
            }).catch(() => {
                 this.$emit('error', 'Não foi possível alterar o veículo')
            })
        },
        async pegarVeiculos () {
            if (this.veiculo_data.identificacao === this.veiculo.identificacao) {
                this.placa_existe = false
                return
            }
            const veiculos = await this.$store.dispatch('pegarVeiculos', {
                identificacao: this.veiculo_data.identificacao,
                ativo: true
            })

            if (veiculos.length > 0) {
                veiculos.map((veiculo) => {
                    if (veiculo.id_veiculo !== this.veiculo.id_veiculo) {
                        this.placa_existe = true
                    }
                })
            } else {
                 this.placa_existe = false
            }
        },
        titulo () {
            switch (this.step) {
                case 2: return 'Editar Dados Veículo'
                case 3: return 'Trocar Usuário Responsável'
                case 4: return 'Trocar Empresa Responsável'
                case 5: return 'Trocar Funcionário Responsável'
            }
        },
        formatarCor (cor) {
            if (cor === null) return ''
            if (cor === undefined) return ''
            if (cor.length === 6) return `#${cor}`
            if (cor.length === 7) return cor
            if (cor.length === 9) return cor.slice(0, 7)
            else {
                let teste = parseInt(cor)
                teste = teste.toString(16)
                return `#${teste.slice(2, 8)}`
            }
        },
        formatarCep (cep) {
            if (!cep) return 'Indefinido'
            if (cep.length < 8) return 'Indefinido'
            if (cep.length === 8) return `${cep.slice(0, 5)}-${cep.slice(5, 8)}`
            return cep
        },
        formatarTelefone (telefone) {
            if (!telefone) return 'Indefinido'
            if (telefone.length < 8) return 'Indefinido'
            if (telefone.length === 8) return `${telefone.slice(0, 4)}-${telefone.slice(4, 8)}`
            if (telefone.length === 9) {
                if (telefone.search('-') === -1) return `${telefone[0]}${telefone.slice(1, 4)}-${telefone.slice(5, 9)}`
                return telefone
            }
            if (telefone.length === 10) return `+(${telefone.slice(0, 2)}) ${telefone.slice(2, 6)}-${telefone.slice(6, 10)}`

            if (telefone.length === 11) return `(${telefone.slice(0, 2)}) ${telefone[2]} ${telefone.slice(3, 7)}-${telefone.slice(7, 11)}`

            if (telefone.length === 14) return `${telefone.slice(0, 3)} (${telefone.slice(3, 5)}) ${telefone[5]} ${telefone.slice(6, 10)}-${telefone.slice(10, 14)}`

            return telefone
        }
    },
    beforeMount () {
        this.veiculo_data = { ...this.veiculo }
    },
    watch: {
        pesquisa (valor) {
            if (valor) {
                this.pegarClientes()
            }
        },
        pesquisa_empresa (valor) {
            if (valor) {
                this.pegarEmpresas()
            }
        },
        pesquisa_motorista (valor) {
            if (valor) {
                this.pegarFuncionarios()
            }
        },
        'veiculo_data.identificacao' (val) {
            if (val) {
                this.pegarVeiculos()
            }
        }
    }
}
</script>
